export const TAB_ID_KEY = 'TAB_ID';
// STORED_TABS is a map of { [tabId]: lastSeenMs }
export const STORED_TABS_KEY = 'STORED_TABS';
export const HEARTBEAT_INTERVAL_MS = 5_000;
// 120 s gives a background tab room to survive Chrome's intensive timer-throttling
// (which clamps setInterval to ~1 min after 5 min in the background) without
// being falsely pruned and triggering logout while the user still has a live tab.
export const TAB_TTL_MS = 120_000;
